import apiService from './api';
import type { ApiService } from './api';

class UploadService {
  constructor(private apiService: ApiService) {}

  public uploadFile(file: File | Blob, type: string, filename?: string, refId?: string | number, invoiceId?: number) {
    const formData = new FormData();

    formData.append('upload_type', type);

    if (type === 'prova_acesso') {
      formData.append('invoice_id', invoiceId.toString());
    }

    if (filename) {
      formData.append('file', file, filename);
    } else {
      formData.append('file', file);
    }

    if (refId) {
      formData.append('ref_id', refId.toString());
    }

    return this.apiService.post('/files', formData).toPromise();
  }
}

const uploadService = new UploadService(apiService);
export default uploadService;
